import React, { FunctionComponent, ReactNode } from 'react';
import classNames from 'classnames';

interface VehicleDetailTitledSectionProps {
  children: ReactNode;
  title: string | ReactNode;
  className?: string;
  noHeading?: boolean;
}

const VehicleDetailTitledSection: FunctionComponent<
  VehicleDetailTitledSectionProps
> = ({ children, title, className, noHeading = false }) => {
  const titleClasses = 'mb-6 text-lg font-semibold block';

  return (
    <section className={classNames('vehicle-details-section', className)}>
      {noHeading ? (
        <span className={titleClasses}>{title}</span>
      ) : (
        <h2 className={titleClasses}>{title}</h2>
      )}

      {children}
    </section>
  );
};

export default VehicleDetailTitledSection;
